<template>
  <div class="card ">
    <a-form class="ant-advanced-search-form" ref="formData" :model="formData" v-if="isCondition">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="商品名称:" prop="title">
            <a-input v-model="formData.title" placeholder="请输入" style="width: 100%" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="昵称:" prop="nickname">
            <a-input v-model="formData.nickname" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="gid:" prop="gid">
            <a-input v-model="formData.gid" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="审核状态:">
            <a-select
                allowClear
                v-model="formData.state"
            >
              <a-select-option :value="item.value" v-for="(item) in records.state_list" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="上架状态:">
            <a-select
                allowClear
                v-model="formData.sale_state"
            >
              <a-select-option :value="item.value" v-for="(item) in records.sale_state_list" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="所属平台:">
            <a-select

                allowClear
                v-model="formData.pvd"
            >
              <a-select-option :value="item.value" v-for="(item) in records.pvd_list" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>

          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="手机号:">
            <a-input v-model="formData.phone" placeholder="请输入" allow-clear>
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="时间:">
            <a-range-picker v-model="formData.dateTime" ref="rangePicker" @change="dateChange" format="YYYY-MM-DD"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="">
            <a-button type="primary" @click="onSubmit">
              提交
            </a-button>
            <a-button style="margin-left: 10px;" @click="onReset">
              重置
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="operate-area">
      <div class="left-btn">
        <a-button icon="redo" type="primary" style="margin-left: 5px; " @click="onRefresh(true)"></a-button>
        <a-button type="primary" style="margin-left: 5px" @click="onAdd">添加商品</a-button>
<!--        <a-button type="danger" icon="delete" style="margin-left: 5px; margin-right: 5px" @click="onDel(null)" :disabled="multipleSelection.length===0">批量删除</a-button>-->
        <a-button type="primary" style="margin-left: 5px; margin-right: 5px" icon="diff" @click="onSubmitReview(multipleSelection,2)" >批量提交</a-button>
        <a-tag :color="index%2==0?'blue':'orange'" v-for="(item,index) in countData" :key="index">
          {{ `${item.name}：${item.value}` }}
        </a-tag>
      </div>
      <div>
        <a-button type="primary" icon="search" @click="onCondition"/>
      </div>
    </div>
    <a-table :data-source="records.list" style="margin-top: 20px;width: 100%" rowKey="id" :pagination="pagination" @change="onPaginationChange" :row-selection="{ onChange: rowSelection }" :loading="loadingPage" bordered>
      <a-table-column goods_info title="商品" width="290px">
        <template slot-scope="scope">
          <div class="record-list">商品序号: <span class="value-price">{{ scope.goods_info.gid }}</span></div>
          <div class="record-list">所属平台: <span class="value-price">{{ scope.goods_info.pvd }}</span></div>
          <div class="record-list ">店铺名称: <span class="value-price">{{ scope.goods_info.store_name }}</span></div>
          <div class="record-list good-title">
            商品标题:
            <a-tooltip>
              <template slot="title">
                {{ scope.goods_info.title }}
              </template>
              {{ scope.goods_info.title }}
            </a-tooltip>
          </div>
          <div class="record-list">
            <div style="display: flex">
              链接：
              <a-tooltip>
                <template slot="title">
                  {{ scope.goods_info.url }}
                </template>
                <div class="good-title" style="width: 200px;">
                  {{ scope.goods_info.url }}
                </div>
              </a-tooltip>
            </div>
          </div>
        </template>
      </a-table-column>
      <a-table-column goods_info title="价格">
        <template slot-scope="scope">
          <div class="record-list">原价:<span class="value-price">{{ scope.goods_info.cost_price ? `¥${scope.goods_info.cost_price}` : '-' }}</span></div>
          <div class="record-list">优惠券:<span class="value-price">{{ scope.goods_info.coupon_price }}</span></div>
          <div class="record-list">券后价:<span class="value-price">{{ scope.goods_info.price ? `¥${scope.goods_info.price}` : '-' }} </span></div>
          <div class="record-list">补贴价: <span class="value-price">{{ scope.goods_info.subsidy_price ? `¥${scope.goods_info.subsidy_price}` : '-' }} </span></div>
          <div class="record-list" style="color: red">服务费:{{ scope.goods_info.fee ? `¥${scope.goods_info.fee}/单` : '-' }}</div>
        </template>
      </a-table-column>
      <a-table-column key="stock" title="推广数量" data-index="stock"/>
      <a-table-column title="扣除明细">
        <template slot-scope="scope">
          <div class="record-list">积分共需扣除数: <span class="value-price">{{ scope.integral_num ? scope.integral_num : '' }}</span></div>
          <div class="record-list">付款人数: <span class="value-price">{{ scope.pay_count ? scope.pay_count : '' }}</span></div>
          <div class="record-list">积分已扣除: <span class="value-price">{{ scope.deduct_num ? scope.deduct_num : '' }}</span></div>
        </template>
      </a-table-column>
      <a-table-column title="商品状态">
        <template slot-scope="scope">
          <span v-if="scope.sale_state_num=='2'" style="color:#EF1818">
            已下架
          </span>
          <span v-else-if="scope.sale_state_num=='1'" style="color: #3DA027">
            已上架
          </span>
          <span v-else style="color: #F77F00"> 未上架</span>
        </template>
      </a-table-column>
      <a-table-column title="审核状态">
        <template slot-scope="scope">
          <span :style="{ color: scope.state == '0' ? '#666666' : scope.state == '1' ? '#F77F00' : scope.state == '2' ? ' #3DA027' : 'red' }">
            {{ scope.state == 0 ? '未提交' : scope.state == 1 ? '待审核' : scope.state == 2 ? '已审核' : '未通过' }}
          </span>
        </template>
      </a-table-column>
      <a-table-column title="时间">
        <template slot-scope="scope">
          <div>
            上架时间: <span style="color: #666666">{{ scope.audit_time ? scope.audit_time : '-' }}</span>
          </div>
          <div>
            下架时间: <span style="color: #666666">{{ scope.end_time ? scope.end_time : '-' }}</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="scope">
          <div>
            <a-button @click="onSubmitReview(scope,1)" class="custom-btn" type="primary" :disabled="scope.state=='1'||scope.state=='2'">提交审核</a-button>
          </div>
          <div  style="margin-top:10px;" v-if="scope.state==='0'">
            <a-button @click="onUpdateView(scope)" class="custom-btn" type="primary" >编辑商品</a-button>
          </div>
          <div style="margin-top:10px;"  v-if="scope.state==='0'">
           <a-button @click="onDel(scope)" class="custom-btn" type="danger">删除</a-button>
          </div>
          <div style="margin-top:10px;" v-if="scope.state==2">
            <a-button @click="onGrounding(scope)" type="danger" class="custom-btn price-btn">
              {{ scope.sale_state_num == '2' ? '上架' : '下架' }}
            </a-button>
          </div>
        </template>
      </a-table-column>
    </a-table>
    <ProcessDialog ref="processDialog" @on-refresh="_fetchData"/>
    <ProductUpDialog ref="productUpDialog" @on-refresh="_fetchData"/>
    <ProductUpdateDialog ref="productUpdateDialog" @on-refresh="_fetchData"/>
    <AddDialog ref="addDialog" @on-refresh="_fetchData"/>
  </div>
</template>

<script>
import ProcessDialog from './components/process-dialog'
import AddDialog from './components/add-dialog'
import {fetchGoodData, goodCount, goodDel, goodGrounding} from "@/api/merchant-registration";
import ProductUpDialog from "@/pages/Business/goods-manager/components/product-up-dialog";
import ProductUpdateDialog from "@/pages/Business/goods-manager/components/product-update-dialog";

export default {
  components: {ProductUpDialog,ProductUpdateDialog, ProcessDialog, AddDialog},
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      loadingPage: true,
      multipleSelection: [],
      isCondition: false,
      formData: {
        dateTime: [],
        "pvd": "",
        "state": "",
        "sale_state": "",//1上架 2下架
        "nickname": "",
        "phone": "",
        "title": "",
        "gid": "",
        "start_time": "",
        "end_time": "",
      },
      records: {
        sale_state_list: [],
        pvd_list: [],
        state_list: []
      },
      countData: []
    }
  },
  mounted() {
    this.onRefresh()
  },
  methods: {
    onRefresh(isRefresh = false) {
      this._fetchData(isRefresh)
      this._fetchGoodData()
    },
    onSubmitReview(row, type = 0) {
      this.$refs.processDialog.show(row, type)
    },
    onGrounding(row) {
      let state = '2'
      if (row.sale_state_num === '2') {
        state = '1'
        this.$refs.productUpDialog.show(row)
      }else{
        const that = this
        this.$confirm({
          title: '删除提示',
          content: row.sale_state_num == '2' ? '确定上架商品吗？' : '确定下架商品吗？',
          okType: 'danger',
          onOk() {
            goodGrounding({
              "gid": row.goods_info.gid,
              "state": state
            }).then(() => {
              that.$message.success('操作成功')
              that._fetchData()
            })
          },
          onCancel() {
          },
        });
      }

    },
    onUpdateView(row) {
        this.$refs.productUpdateDialog.show(row)
    },
    onDel(row) {
      let delTitle = ''
      let ids = ''
      if (row === null) {
        delTitle = `确定要删除所选的${this.multipleSelection.length}个商品吗，删除后不可恢复`
        ids = this.multipleSelection.join(',')
      } else {
        delTitle = '确定要删除吗，删除后不可恢复'
        ids = row.id
      }
      const that = this
      this.$confirm({
        title: '删除提示',
        content: delTitle,
        okType: 'danger',
        onOk() {
          goodDel({ids: ids}).then(() => {
            that._fetchData()
          })
        },
        onCancel() {
        },
      });


    },
    onAdd() {
      this.$refs.addDialog.show()
    },
    dateChange(_, dateString) {
      this.formData.start_time = dateString[0]
      this.formData.end_time = dateString[1]
    },
    onReset() {
      this.formData.title = ''
      this.formData.state = ''
      this.formData.sale_state = ''
      this.formData.nickname = ''
      this.formData.phone = ''
      this.formData.gid = ''
      this.formData.pvd = ''
      this.formData.start_time = ''
      this.formData.end_time = ''
      this.formData.dateTime = null
    },
    onSubmit() {
      this.loadingPage = true
      this.pagination.current = 1
      this._fetchGoodData()
      this._fetchData()
    },
    _fetchData(isRefresh = false) {
      let params = JSON.parse(JSON.stringify(this.formData))
      params.p = this.pagination.current + ''
      params.size = this.pagination.pageSize + ''
      delete params.dateTime
      fetchGoodData(params).then(resp => {
        if (isRefresh) {
          this.$message.success('刷新成功')
        }
        this.loadingPage = false
        this.records = resp
        this.pagination.total = resp.total
      })


    },
    _fetchGoodData() {
      let params = JSON.parse(JSON.stringify(this.formData))
      delete params.dateTime
      goodCount(params).then(resp => {
        resp = resp ? resp : []
        resp.map(item => {
          item.value = item.value ? item.value : 0
        })
        this.countData = resp
      })
    },
    onCondition() {
      this.isCondition = !this.isCondition
    },
    rowSelection(values) {
      this.multipleSelection = values
    },
    onPaginationChange(pagination) {
      console.log(pagination, this.pagination)
      this.pagination = pagination
      this._fetchData()
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 24px;
  min-height: 90vh;
}

.left-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep .ant-tag {
  margin-right: 5px;
  height: 30px;
  line-height: 30px;
}

.value-price {
  color: #666;
}

.record-list {
  line-height: 30px;
}

.good-title {
  width: 266px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.data-card {
  display: flex;
  justify-content: space-around;
}

::v-deep .ant-col-5 {
  width: 14.266666%;
}


.ant-advanced-search-form {
  margin-top: 60px;
  padding-left: 40px;
  padding-right: 40px;

  .ant-form-item {
    display: flex;
  }


  ::v-deep .ant-form-item-label label {
    font-size: 14px;
    font-weight: 400;
    color: #606060;
  }

  ::v-deep .ant-form-item-control-wrapper {
    flex: 1;
  }

  ::v-deep .ant-form {
    max-width: none;
  }
}

.operate-area {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: center;

  .success-btn {
    background: #67c23a;
    color: #fff;
    border-color: #67c23a;
  }
}

.price-btn {
  background: #F77F00 !important;
  border-color: #F77F00 !important;
}

.custom-btn {
  width: 88px;
}


.col-item {
  border-radius: 12px;
  padding: 21px 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .card-title {
    font-size: 17px;
    font-weight: 400;
    color: #FFFFFF;
  }

  .card-value {
    font-size: 35px;
    font-family: ' DIN, DIN';
    font-weight: 500;
    color: #FFFFFF;
  }
}


</style>
